module.exports = __webpack_public_path__ + "img/05—Applications—Home app.92774495.jpg";